import { api } from '@/api';
import router from '@/router';
import { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import {
    commitSetDashboardLessons,
    commitSetNewBook,
} from './mutations';
import { DashboardState } from './state';
import { dispatchCheckApiError } from '../main/actions';

type MainContext = ActionContext<DashboardState, State>;

export const actions = {
     async actionGetDashboardLessons(context: MainContext) {
         try {
             const response = await api.getDashboardLessons(context.rootState.main.token);
             if (response.data) {
                 commitSetDashboardLessons(context, response.data);
             }
         } catch (error) {
             await dispatchCheckApiError(context, error);
             commitSetDashboardLessons(context, []);
         }
     },
     async actionGetNewBook(context: MainContext) {
         try {
             const response = await api.getNewBook(context.rootState.main.token);
             if (response.data) {
                 commitSetNewBook(context, response.data);
             }
         } catch (error) {
             await dispatchCheckApiError(context, error);
             commitSetNewBook(context, null);
         }
     },
};

const { dispatch } = getStoreAccessors<DashboardState | any, State>('');

export const dispatchGetDashboardLessons = dispatch(actions.actionGetDashboardLessons);
export const dispatchGetNewBook = dispatch(actions.actionGetNewBook);
